import React from "react";

type Props = {
  onDeselectAll: () => void;
  onSelectAll: () => void;
};

const SelectDeselectAll = ({ onSelectAll, onDeselectAll }: Props) => {
  return (
    <div className="flex mb-5">
      <div
        className="cursor-pointer mr-5 text-smart-teal"
        onClick={onSelectAll}
      >
        Select All
      </div>
      <div className="cursor-pointer text-smart-teal" onClick={onDeselectAll}>
        Deselect All
      </div>
    </div>
  );
};

export default SelectDeselectAll;
